module.exports = __webpack_public_path__ + "img/fangwen.b8e6d816.svg";